<template>
  <div>
    <div id="pdf" :style="componentStyles">
      <component ref="pdfContent" :is="component" v-bind="componentProps"/>
    </div>
    <loader-pdf ref="loaderPdf" />
  </div>
</template>
<script>
import loaderPDF from './components/loader.vue'
import html2canvas from 'html2canvas'
import { jsPDF as JsPDF } from 'jspdf';
import ReportFRP from '../reports/ReportFRP.vue'
export default {
  data(){
    return {
      html: '<h1>Sin datos para mostrar.</h1>',
      componentStyles: {
        position: 'absolute',
        top: '-9999px',
        left: '-9999px',
        width: '1440px',
      }
    }
  },
  props:{
    component: {
      type: String,
      required: true
    },
    componentProps: {
      type: Object,
      default: () => ({})
    },
    namePdf: {
      type: String,
      required: true
    },
  },
  methods:{
    async downloadPdf () {
      try {
        this.loader()
        setTimeout(() => {
          // Time for render
        }, 10000)
        await this.$nextTick(() => {
          const elementToCapture = document.getElementById('pdf');

          html2canvas(elementToCapture, {
            useCORS: true,
            scale: 1
          }, {
            useCORS: true,
            allowTaint: true,
            imageTimeout: 5000,
          }).then(canvas => {
          const pdf = new JsPDF({
            orientation: 'portrait',
            format: 'a4',
            unit: 'px',
          });

          const pageSize = pdf.internal.pageSize;
          const pageWidth = pageSize.getWidth();
          const pageHeight = pageSize.getHeight();

          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          const imgData = canvas.toDataURL('image/jpeg', 0.95);

          let heightLeft = imgHeight;
          let position = 0;

          // Agregar la primera sección de la imagen
          pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
          position += pageHeight;

          // Agregar secciones sucesivas de la imagen
          while (heightLeft > 0) {
            pdf.addPage();
            pdf.addImage(imgData, 'JPEG', 0, -position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            position += pageHeight;
          }

          // Descargar el archivo PDF
          pdf.save(`${this.namePdf}.pdf`);
          this.loader()
          });
        });
      } catch (err) {
        console.log(err)
        this.loader()
        await this.$store.dispatch("notify", {
          message: 'Error al descargar el reporte.',
          type: 'is-danger',
        });
      }
    },
    loader(){
      this.$refs.loaderPdf.switchLoader();
    }
  },
  components:{
    ReportFRP,
    'loader-pdf': loaderPDF
  }
}
</script>
<style >
.hidden {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/Pdf.vue